import { useEffect } from 'react';

import { useHistory } from 'cross-platform/react-router';

export const useDispatchPathToParent = (): void => {
  const history = useHistory();
  const path = history.location.pathname;
  useEffect(() => {
    window.top?.postMessage(JSON.stringify({ clientPath: path }), '*');
  }, [path]);
};
